<template>
  <div class="message-forward-dropdown">
      <MiniMember
        v-for="(dialog, i) in groups"
        :key="i"
        :dialog="dialog"
        @click.native="$emit('select', dialog)"
      />
  </div>
</template>

<script>
import MiniMember from '@/components/chat/MiniMember.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'MessageForwardDropdown',
  components: { MiniMember },
  computed: {
    ...mapGetters('chat', ['groups'])
  },
}
</script>

<style lang="scss">
.message-forward-dropdown {
  position: absolute;
  top: 45px;
  left: -216px;
  z-index: 9;

  max-height: 312px;
  overflow: auto;

  background: #FFFFFF;
  box-shadow: 0px 12px 21px 0px #B4BBC630;
  border-radius: 5px;
  padding: 12px 8px;
  width: 200px;
}
</style>
